module.exports = __webpack_public_path__ + "front/img/32.7a21f8d4.png";